import React, { useRef } from 'react';
import BasePage from '../../../../core/page/BasePage';
import BaseFilter from '../../../../core/page/components/baseFilter/BaseFilter';
import Pages from '../../../../config/Pages';
import { inputsDadosGerais } from '../PageInputs';
import RotuloSeplag from '../../../../components/rotuloSeplag/RotuloSeplag';
import AutoCompleteDropDown from '../../../../core/components/inputs/AutoCompleteDropDown';
import { InputText } from 'primereact/inputtext';
import InputDropDown from '../../../../core/components/inputs/inputDropDown/InputDropDown';
import builder from '@rsql/builder';
import ActionButtons from '../components/ActionButtons';
import styles from './PropostaIndicadorListagem.module.scss';
import ButtonSeplag from '../../../../components/buttonSeplag/ButtonSeplag';
import { useOrgao } from '../../Utils';
import { useInputs } from '../../../../core/utils/Hooks';
import LinkTo from '../../../../core/components/LinkTo';
import ModalJustificativa from '../components/modalJustificativa/ModalJustificativa';
import ConfirmDialog from '../../../../core/components/ConfirmDialog';
import propostaIndicadorService from '../../../../service/PropostaIndicadorService';
import orgaoIntegracaoService from '../../../../service/integracao/OrgaoIntegracaoService';
import unidadeOrcamentariaIntegracaoService from '../../../../service/integracao/UnidadeOrcamentariaIntegracaoService';
import subtipoIndicadorService from '../../../../service/SubtipoIndicadorService';
import tipoIndicadorService from '../../../../service/TipoIndicadorService';
import situacaoPropostaService from '../../../../service/SituacaoPropostaService';
import { isEmpty } from '../../../../core/utils/ValidForm';

function PropostaIndicadorListagem() {
    const orgaoUsuarioLogado = useOrgao();
    const filterInputs = useInputs(inputsDadosGerais);
    const modalJustificativaRef = useRef(null);
    const confirmRef = useRef(null);
    const formRef = useRef(null);
    const tipoIndicadorRef = useRef(null);
    const desdobramentoRef = useRef(null);
    const unidadeOrcamentariaRef = useRef(null);
    const mensagemRef = useRef(null);

    const Rotulo = ({ children, ...rest }) => (
        <RotuloSeplag useInput={filterInputs} {...rest}>
            {children}
        </RotuloSeplag>
    );

    const Inputs = ({ formik }) => {
        return (
            <>
                <Rotulo cols="12 6">
                    <AutoCompleteDropDown
                        name="orgao"
                        formik={formik}
                        field="descOrgao"
                        disabled={orgaoUsuarioLogado?.siglOrgao !== 'SEPLAG'}
                        service={orgaoIntegracaoService.autoComplete.bind(orgaoIntegracaoService)}
                        onSelect={async (ev) => {
                            const { idenOrgao } = ev?.value ?? {};
                            const response = await unidadeOrcamentariaIntegracaoService.getByOrgao(
                                idenOrgao
                            );
                            unidadeOrcamentariaRef.current?.setLista(response);
                        }}
                    />
                </Rotulo>
                <Rotulo cols="12 6">
                    <InputDropDown
                        ref={unidadeOrcamentariaRef}
                        name="unidadeOrcamentaria"
                        valueIsCompleteObject
                        formik={formik}
                        disabled={orgaoUsuarioLogado?.siglOrgao !== 'SEPLAG'}
                        optionLabel="descricaoUnidadeOrcamentaria"
                        optionValue="idenUo"
                    />
                </Rotulo>
                <Rotulo cols="12 3">
                    <InputText
                        name="usuarioCadastro"
                        value={formik.values.usuarioCadastro}
                        onChange={formik.handleChange}
                        disabled={orgaoUsuarioLogado?.siglOrgao !== 'SEPLAG'}
                    />
                </Rotulo>
                <Rotulo cols="12 2">
                    <InputText
                        name="numeroProposta"
                        value={formik.values?.numeroProposta}
                        onChange={formik.handleChange}
                    />
                </Rotulo>
                <Rotulo cols="12 3">
                    <InputText
                        name="nmIndicador"
                        value={formik.values.nmIndicador}
                        onChange={formik.handleChange}
                    />
                </Rotulo>
                <Rotulo cols="12 4">
                    <InputText
                        name="responsavelIndicador"
                        value={formik.values.responsavelIndicador}
                        onChange={formik.handleChange}
                    />
                </Rotulo>
                <Rotulo cols="12 4">
                    <InputDropDown
                        ref={tipoIndicadorRef}
                        name="tipoIndicador"
                        formik={formik}
                        valueIsCompleteObject
                        optionLabel="descTipoIndicador"
                        callbackSetList={tipoIndicadorService.list.bind(tipoIndicadorService)}
                        onChange={async (ev) => {
                            const item = tipoIndicadorRef.current?.lista.find(
                                (el) => el?.id === ev.value
                            );
                            formik.setFieldValue('tipoIndicador', item);
                            const response = await subtipoIndicadorService.list(
                                isEmpty(item?.id)
                                    ? null
                                    : {
                                          params: { search: `tipoIndicador.id==${item.id}` },
                                      }
                            );
                            desdobramentoRef.current?.setLista(response);
                        }}
                    />
                </Rotulo>
                <Rotulo cols="12 3">
                    <InputDropDown
                        ref={desdobramentoRef}
                        name="desdobramento"
                        formik={formik}
                        callbackSetList={subtipoIndicadorService.list.bind(subtipoIndicadorService)}
                        valueIsCompleteObject
                        optionLabel="descSubtipoIndicador"
                    />
                </Rotulo>
                <Rotulo cols="12 2">
                    <InputDropDown
                        name="situacao"
                        formik={formik}
                        optionLabel="descSituacao"
                        valueIsCompleteObject
                        callbackSetList={situacaoPropostaService.list.bind(situacaoPropostaService)}
                    />
                </Rotulo>
            </>
        );
    };

    return (
        <>
            <ModalJustificativa
                ref={modalJustificativaRef}
                onSave={({ success }) => {
                    if (success) {
                        modalJustificativaRef.current?.hide();
                        formRef.current.formik.submitForm();
                    }
                }}
            />
            <ConfirmDialog ref={confirmRef} />
            <ConfirmDialog ref={mensagemRef} isOk header={'Atenção'} />
            <BasePage
                service={propostaIndicadorService}
                labelIncluir="Proposta de Indicador"
                className={styles.page}
                page={{
                    pageUrls: Pages.sei.propostaIndicador.url,
                    legenda: Pages.sei.propostaIndicador.legenda,
                    pageName: Pages.sei.propostaIndicador.title,
                }}
                initialValues={inputsDadosGerais.filter((input) => input?.table?.use ?? false)}
                addAfterActions={(data) => (
                    <ActionButtons
                        confirmRef={confirmRef}
                        modalJustificativaRef={modalJustificativaRef}
                        mensagemRef={mensagemRef}
                        formRef={formRef}
                        data={data}
                    />
                )}
                addBeforeActions={(data) => (
                    <LinkTo to={Pages.sei.statusProposta.url.list.replace(':id', data.id)}>
                        <ButtonSeplag
                            tipo="help"
                            type="button"
                            tooltip="Status da Proposta"
                            tooltipOptions={{ position: 'top' }}
                            icon="pi pi-arrow-right-arrow-left"
                            style={{ marginRight: '.5em', marginTop: '.2em' }}
                        />
                    </LinkTo>
                )}
                enableAlterar={false}
                enableEditar={false}
                enableExcluir={false}
            >
                <BaseFilter
                    ref={formRef}
                    initialValues={inputsDadosGerais.filter((input) => input?.filter?.use ?? false)}
                    prepareInitialValues={async (dados) => {
                        const { idenOrgao } = orgaoUsuarioLogado;
                        if (idenOrgao) {
                            unidadeOrcamentariaIntegracaoService
                                .getByOrgao(idenOrgao)
                                .then((response) =>
                                    unidadeOrcamentariaRef.current?.setLista(response)
                                );
                        }

                        return { ...dados, orgao: orgaoUsuarioLogado };
                    }}
                    noEmptyInputsOnClear={orgaoUsuarioLogado?.siglOrgao === 'SEPLAG'}
                    customFilter={{
                        orgao: ({ nameUse, original }) =>
                            builder.comparison(nameUse, '==', original?.idenOrgao),
                        unidadeOrcamentaria: ({ nameUse, original }) =>
                            builder.comparison(nameUse, '==', original?.idenUo),
                        situacao: ({ nameUse, original }) =>
                            builder.comparison(nameUse, '==', original?.id),
                        desdobramento: ({ nameUse, original }) =>
                            builder.comparison(nameUse, '==', original?.id),
                        tipoIndicador: ({ nameUse, original }) =>
                            builder.comparison(nameUse, '==', original?.id),
                    }}
                >
                    <Inputs />
                </BaseFilter>
            </BasePage>
        </>
    );
}

export default PropostaIndicadorListagem;
